module.exports = __webpack_public_path__ + "static/media/arrow-select.d2f5ab68.svg";